export default __webpack_public_path__ + "static/media/grandlale3.7c74e78b.jpg";